import { equals, propOr } from 'ramda';

export const extraMailInfos = ({ getMiddleText, risque, nomClient, customerEmail, context }) => {

  const isSouscriptionRecap = equals(
    'SOUSCRIPTION_RECAP',
    propOr('', 'viewId', context)
  );

  const objectKey = isSouscriptionRecap
    ? 'EMAIL_RECAP_OBJECT_DEFAULT_VALUE'
    : 'EMAIL_OBJECT_DEFAULT_VALUE';

  const bodyKey = isSouscriptionRecap
    ? 'EMAIL_RECAP_BODY_DEFAULT_VALUE'
    : 'EMAIL_BODY_DEFAULT_VALUE';

  return {
    object: getMiddleText(objectKey, { risque, nomClient }),
    body: getMiddleText(bodyKey, { risque, nomClient }),
    email: customerEmail
  };
};
